import { Loader2 } from 'lucide-react'

export function Spinner({ label = 'Загружаем' }: { label?: string }) {
  return (
    <div role="status" className="flex min-h-[50vh] items-center justify-center gap-3 text-ink-soft">
      <Loader2 aria-hidden className="size-5 animate-spin" />
      <span className="text-meta">{label}…</span>
    </div>
  )
}
